import AppIndex from './pages/index.jsx';
import RolePage from './pages/Role/index.js';
import UserPage from './pages/User/index.js';

export const Role = RolePage;
export const User = UserPage;
export const Layout = AppIndex;
